/**
 * Copyright (c) 2024 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { ID_PORTAL_MIGRATION_STATE_UPDATE } from '../actions/actionTypes';

const idPortalMigrationState = {
  idPortalStatus: null
};

const idPortalMigrationReducer = (state = idPortalMigrationState, action) => {
  switch (action.type) {
    case ID_PORTAL_MIGRATION_STATE_UPDATE: {
      return Object.assign({}, state, { idPortalStatus: action.payload });
    }
    default:
      return state;
  }
};

export default idPortalMigrationReducer;
